const chooseTypes = {
    picker: 'picker',
    select: 'select'
} as const

export { chooseTypes }
